<template>
  <div>
    <!-- Add/Update Admin Form START -->
    <v-dialog persistent v-model="adminActionsModal" max-width="1000">
      <v-card>
        <v-card-title class="headline indigo lighten-2">
          <div class="text-center white--text" style="width: 100%">
            {{ $t(`buttons.${isUpdate ? "update" : "add"}`) }}
          </div>
        </v-card-title>
        <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
          <form @submit.prevent="handleSubmit(submitForm())">
            <v-card-text class="align-center">
              <ValidationProvider
                :name="$t('labels.userUsername')"
                rules="required|numeric"
                v-slot="{ errors }"
                ><v-text-field
                  v-model="form.Username"
                  :label="$t('labels.userUsername')"
                  outlined
                  :hint="$t('descriptions.usernameWarning')"
                  :error-messages="errors[0]"
                ></v-text-field
              ></ValidationProvider>
              <ValidationProvider
                :name="$t('labels.firstName')"
                rules="required|alpha"
                v-slot="{ errors }"
                ><v-text-field
                  v-model="form.Name"
                  :label="$t('labels.firstName')"
                  outlined
                  :error-messages="errors[0]"
                ></v-text-field
              ></ValidationProvider>
              <ValidationProvider
                :name="$t('labels.lastName')"
                rules="required"
                v-slot="{ errors }"
                ><v-text-field
                  v-model="form.Surname"
                  :label="$t('labels.lastName')"
                  outlined
                  :error-messages="errors[0]"
                ></v-text-field
              ></ValidationProvider>
              <ValidationProvider
                :name="$t('labels.password')"
                rules="required"
                v-slot="{ errors }"
                ><v-text-field
                  v-model="form.Password"
                  :label="$t('labels.password')"
                  outlined
                  :error-messages="errors[0]"
                  type="password"
                ></v-text-field
              ></ValidationProvider>
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn
                small
                class="ma-2 mr-4"
                type="submit"
                elevation="0"
                large
                outlined
                color="red"
              >
                {{ $t(`buttons.${isUpdate ? "update" : "add"}`) }}
              </v-btn>
              <v-btn
                small
                class="ma-2 mr-4"
                elevation="0"
                large
                outlined
                color="grey"
                @click="adminActionsModal = false"
              >
                {{ $t("buttons.cancel") }}
              </v-btn>
            </v-card-actions>
          </form>
        </ValidationObserver>
      </v-card>
    </v-dialog>
    <!-- Add/Update Admin Form END -->

    <!-- Emergency deletion modal -->
    <delete-modal :yesFunc="deleteItem" ref="deleteModalRef" />
    <!-- Page content -->
    <v-card style="border-radius: 10px">
      <v-card-title style="color: #595959">
        <v-row>
          <v-col class="py-2">{{ $t("navigationDrawerMenu.adminList") }}</v-col>
          <v-spacer />
          <v-btn
            small
            class="ma-2 mr-4"
            elevation="0"
            outlined
            color="info"
            @click="
              isUpdate = false;
              adminActionsModal = true;
            "
          >
            {{ $t("buttons.addNewAdmin") }}
          </v-btn>
        </v-row>
      </v-card-title>

      <v-divider />

      <v-card-text class="pt-4">
        <v-row justify="end">
          <v-col cols="2">
            <v-select
              v-model="itemsPerPage"
              :items="perPageValues"
              :label="$t('labels.selectItemsPerPage')"
              item-value="value"
              item-text="name"
              @change="changeItemsPerPage()"
            >
            </v-select>
          </v-col>
        </v-row>
        <v-data-table
          :headers="headers"
          :items="tableData"
          :loading="$store.state.loadingStatus"
          :options.sync="options"
          :hide-default-footer="true"
          :footer-props="{
            disablePagination: true,
            disableItemsPerPage: true,
          }"
          :no-data-text="$t('description.noList')"
        >
          <!-- eslint-disable -->
          <template v-slot:item.FullName="{ item }">
            {{ `${item.Name} ${item.Surname}` }}
          </template>

          <template v-slot:item.actions="{ item }">
            <v-tooltip top v-if="item.AnswerCount">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  class="mr-2"
                  @click="downloadExcel(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-download
                </v-icon>
              </template>
              <span>{{ $t("labels.emergencyDownload") }}</span>
            </v-tooltip>
            <v-tooltip v-if="item.EventStatus !== 2" top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  class="mr-2"
                  @click="
                    adminActionsModal = true;
                    changeActiveEvent(item, true);
                  "
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span>{{ $t("labels.tooltipEdit") }}</span>
            </v-tooltip>
            <v-tooltip v-if="item.EventStatus !== 2" top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  class="mr-2"
                  @click="openDeleteModal(item.Id)"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-delete
                </v-icon>
              </template>
              <span>{{ $t("labels.tooltipDelete") }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <div v-if="pages > 0" class="text-xs-center pt-2 md4 lg4">
          <v-pagination
            @input="paginationChangeHandler"
            :value="pagination.page"
            :length="pages"
            :total-visible="10"
            circle
          ></v-pagination>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import DeleteModal from "../components/General/DeleteModal";
import AdminService from "../services/AdminService";

export default {
  data: () => ({
    // List options
    options: {
      itemsPerPage: 15,
    },
    top: 15,
    skip: 0,
    tableData: [],
    headers: [],

    //Pagination models
    pagination: {
      totalItems: 200,
      rowsPerPage: 15,
      page: 1,
    },
    itemsPerPage: 15,
    perPageValues: [10, 15, 30, 50, 100],

    form: {},
    adminActionsModal: false,
    isUpdate: false,
    deleteId: null,
  }),

  watch: {
    adminActionsModal(newValue) {
      if (!newValue) {
        this.reset();
      }
    },
  },
  mounted() {
    this.setup();
    this.getItems();
  },
  components: {
    DeleteModal,
  },

  computed: {
    totalRecords() {
      return this.items.length;
    },
    pageCount() {
      return this.totalRecords / this.itemsPerPage;
    },
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
  },

  methods: {
    setup() {
      this.pagination.rowsPerPage = this.itemsPerPage;

      this.headers = [
        {
          text: this.$t("labels.username"),
          value: "Username",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("labels.firstName") + " " + this.$t("labels.lastName"),
          value: "FullName",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("title.tableHeaderActions"),
          value: "actions",
          sortable: false,
          align: "center",
        },
      ];
    },

    getItems() {
      this.$store.state.loadingStatus = true;

      AdminService.getList({
        Page: this.pagination.page,
        PageSize: this.pagination.rowsPerPage,
      })
        .then((response) => {
          const data = response.data;
          if(data){
            this.tableData = data?.Result || [];
            this.pagination.totalItems = data.TotalItems;
          }
        })
        .catch(window.showError)
        .then(() => {
          this.$store.state.loadingStatus = false;
        });
    },

    /**
     * Change active event for click actions.
     * @param {any} item
     * @param {boolean} isUpdate
     */
    changeActiveEvent(item, isUpdate = false) {
      this.form = Object.assign({}, item);
      delete this.form.Password;
      this.isUpdate = isUpdate;
    },

    submitForm() {
      this.$store.state.loadingStatus = true;
      AdminService[this.isUpdate ? "update" : "createAdmin"](this.form)
        .then((response) => {
          this.getItems();
          this.adminActionsModal = false;

          window.showSuccess(this.$t(`messages.${this.isUpdate ? 'updatedSuccessfully' : 'addedAdminSuccessfully'}`));
        })
        .catch(window.showError)
        .finally(() => (this.$store.state.loadingStatus = false));
    },

    reset() {
      this.form = {};
      if (this.$refs.observer) {
        this.$refs.observer.reset();
      }
    },

    openDeleteModal(id) {
      this.deleteId = id;
      this.$refs.deleteModalRef.modalStatus = true;
    },

    //Delete operation
    deleteItem() {
      this.$store.state.loadingStatus = true;
      AdminService.delete(this.deleteId)
        .then(() => {
          this.reset();
          window.showInfo(
            this.$t("messages.deletedSuccessfully"),
            "standart",
            "info"
          );
          this.getItems();
          this.$refs.deleteModalRef.modalStatus = false;
        })
        .catch(window.showError)
        .then(() => {
          this.$store.state.loadingStatus = false;
        });
    },

    //Change displayed items per page, page number one is default
    changeItemsPerPage() {
      this.pagination.rowsPerPage = this.itemsPerPage;
      this.pagination.page = 1;
      this.options.itemsPerPage = this.itemsPerPage;
      this.getItems();
    },

    //Change list pagination page
    paginationChangeHandler(pageNumber) {
      this.pagination.page = pageNumber;
      this.getItems();
    },
  },
};
</script>
